import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import Prompt from '../../widgets/Prompt';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import FormDialog from "../FormDialog";
import { ShortCourseOutcomeForm } from "../program/ShortCourseOutcomeForm";
import ProviderShortCourseSearchModule from "../program/ProviderShortCourseSearchModule";
import LinkDialog from "../LinkDialog";
import ProviderInterventionAudit from '../provider/ProviderInterventionAudit';

const headCells = [
    { id: 'ShortCourseCode', numeric: false, disablePadding: false, label: 'Short Course Code' },
    { id: 'ShortCourseTitle', numeric: false, disablePadding: false, label: "Short Course Title" },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: false, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: false, label: 'Registration End Date' },
    { id: 'ProgramOutcome', numeric: false, disablePadding: false, label: 'Program Outcome' },
];

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

class ProviderShortCourseSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showTable: true,
            selectedShortCourse: null,
            selectedShortCourseTitle: null,
            linkDialogOpen: false,
            auditDialogOpen: false,
            formDialogOpen: false,
            searchParameters: [{ Name: "ProviderID", Value: this.props.location.state.selection }],
            propmtOpen: false,
            promptTitle: "Remove Short Course from Provider",
            promptContent: "Are you sure you want to remove this Short Course from the provider?",
            removeMessage: "",
            removeMessageStyle: "",

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: "link", label: '', icon: 'LinkIcon', tooltip: "Link existing ShortCourse to provider" },
                        {
                            id: 'view', label: '', icon: 'UpdateIcon', tooltip: 'Update Outcome',
                            disabled: utils.isNull(this.state.selectedShortCourse)
                        },
                        {
                            id: 'audit', label: '', icon: 'AuditIcon', tooltip: 'View Record Audit Trail',
                            disabled: utils.isNull(this.state.selectedShortCourse)
                        },
                        {
                            id: 'remove', label: '', icon: 'DeleteIcon', tooltip: 'Remove ShortCourse from provider',
                            disabled: utils.isNull(this.state.selectedShortCourse)
                        }]
                }
            ]
        };

    }
    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/provider',
                state: { selection: this.props.location.state.selection }
            });
        }
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("view" === buttonId) {
            this.setState({ removeMessage: "" }, this.viewRecords());
        }
        else if ("audit" === buttonId) {
            this.setState({ auditDialogOpen: true, message: "" })
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, removeMessage: "" })

        }
        else if ("unitStandards" === buttonId) {
            this.props.history.push({
                pathname: '/providerShortCourseUSSearch',
                state: {
                    ProviderID: this.props.location.state.selection,
                    ProviderShortCourseID: this.state.selectedShortCourse,
                    SkillsTitle: this.state.selectedShortCourseTitle,
                    providerName: this.props.location.state.providerName,
                    providerSDLNumber: this.props.location.state.providerSDLNumber
                }
            });
        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                formDialogOpen: false, auditDialogOpen: false, selectedSiteVisit: null, linkDialogOpen: false
            }, () => { this.setState({ showTable: true }) });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedShortCourse: selection[0].Id, removeMessage: "", selectedShortCourseTitle: selection[0].ShortCourseTitle });
        } else {
            this.setState({ selectedShortCourse: null, removeMessage: "", selectedShortCourseTitle: null });
        }
        toolbarRef.current.setButtonDisabled("remove", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("view", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("audit", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("unitStandards", selection === null || selection.length === 0);
    }

    successfulRemoveCallback = (response) => {

        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedShortCourse: null,
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                removeMessage: response.Message,
                removeMessageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    removeShortCourse(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
            toolbarRef.current.setButtonDisabled("view", true);
            toolbarRef.current.setButtonDisabled("audit", true);
            toolbarRef.current.setButtonDisabled("unitStandards", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedShortCourse}&providerId=${this.props.location.state.selection}`;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }

    viewRecords = () => {
        this.setState({ formDialogOpen: true })
    }


    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Provider > Short Courses " + (this.props.location.state.providerName !== null ? "> " + this.props.location.state.providerName + (this.props.location.state.providerSDLNumber !== null ? " - " + this.props.location.state.providerSDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.removeMessage} alertStyle={this.state.removeMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (

                        <EnhancedTable
                            headCells={headCells}
                            dataUrl={`api/sims/providerShortCourse/GetProviderShortCourses`}
                            height="60vh"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>

                <FormDialog
                    open={this.state.formDialogOpen}
                    dialogTitle={"Update Outcome"}
                    viewRef={this}
                    formRef={addFormRef}
                    entityId={this.state.selectedShortCourse}
                    saveUrl={"api/sims/providerShortCourse/UpdateShortCourseOutcome"} usePut={true}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <ShortCourseOutcomeForm
                        ref={addFormRef}
                        id={this.state.selectedShortCourse}
                        dataURL='api/sims/providerShortCourse/GetFindShortCourseOutcome'
                    />
                </FormDialog>

                <LinkDialog open={this.state.auditDialogOpen}
                    title={"Audit Trail"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={"Audit Trail"}
                    selectionId={this.props.location.state.selectedShortCourse}
                >

                    <ProviderInterventionAudit dataUrl={"api/sims/providerShortCourse/GetProviderShortCourseAudit"}
                        multiSelect={false} showTitle={false}
                        Id={this.state.selectedShortCourse}
                    />
                </LinkDialog>

                <LinkDialog
                    open={this.state.linkDialogOpen}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={`Link ShortCourse to Provider > ${this.props.location.state.providerName} - ${this.props.location.state.providerSDLNumber}`}
                    linkName={"ShortCourses"} postUrl={"api/sims/providerShortCourse/LinkProviderShortCourse"} usePost={true}
                    selectionId={this.props.location.state.selection}
                >
                    <ProviderShortCourseSearchModule
                        programmeId={this.props.location.state.selection}
                        dataUrl="api/sims/providerShortCourse/GetSearchLinkableShortCourses"
                        mode="lookup"
                        multiSelect={true} showTitle={false}
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.removeShortCourse("api/sims/providerShortCourse/RemoveProviderShortCourse") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ProviderShortCourseSearch)
);
